module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-15-af19d01830bbdf9998cbb6c25d39f447.jpg";